import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { GetItemsPayload } from 'Types/getItemsPayload'
import { CreativesCreateModel, CreativesModel } from 'Pages/advertisement/models'
import { Callback } from 'Src/types/utilTypes'

export type CreativeState = {
	requestParams: RequestParams
	creative_list: ResponseCatalog<CreativesModel>
	creative: CreativesCreateModel | null
	openedCreative: number
}

export const creativeInitialState: CreativeState = {
	requestParams: new RequestParams(),
	creative_list: new ResponseCatalog<CreativesModel>(),
	creative: null,
	openedCreative: null,
}

export namespace creativeNS {
	export type getCreativesList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type setRequestParams = PayloadAction<RequestParams>
	export type setCreativesList = PayloadAction<ResponseCatalog<CreativesModel>>
	export type GetCreatives = PayloadAction<number>
	export type SetCreatives = PayloadAction<CreativesCreateModel>
	export type CreateCreatives = PayloadAction<CreativesCreateModel>
	export type SetCreativeOpened = PayloadAction<number>
	export type ChangeCreativeFromSocket = PayloadAction<{
		creative_id: number
		status: string
		external_id: string
		registered_at: string
		media_state: string
		marker: string
	}>
	export type getCreativeListSelect = PayloadAction<GetItemsPayload>
	export type UpdateCreatives = PayloadAction<{
		id: string
		data: CreativesCreateModel
	}>
	export type ToggleActive = PayloadAction<string>
}

export const creativeSlice = createSlice({
	name: 'creative',
	initialState: creativeInitialState,
	reducers: {
		getAll: (state, action: creativeNS.getCreativesList) => {},
		getListSelect: (state, action: creativeNS.getCreativeListSelect) => {},
		setAll: (state, action: creativeNS.setCreativesList) => {
			state.creative_list = action.payload
		},
		setRequestParams: (state, action: creativeNS.setRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.creative_list = new ResponseCatalog<CreativesModel>()
			state.requestParams = new RequestParams()
		},
		getOne: (state, action: creativeNS.GetCreatives) => {},
		setOne: (state, action: creativeNS.SetCreatives) => {
			state.creative = action.payload
		},
		createOne: (state, action: creativeNS.CreateCreatives) => {},
		updateOne: (state, action: creativeNS.UpdateCreatives) => {},
		setOpened: (state, action: creativeNS.SetCreativeOpened) => {
			state.openedCreative = action.payload
		},
		setToggleActive: (state, action: creativeNS.ToggleActive) => {},
		changeCreativeFromSocket: (state, action: creativeNS.ChangeCreativeFromSocket) => {
			const { creative_id } = action.payload
			const findCreatIndex = state.creative_list.entries.findIndex(
				(creat) => creat.id === creative_id
			)
			if (findCreatIndex) {
				state.creative_list.entries[findCreatIndex] = {
					...state.creative_list.entries[findCreatIndex],
					...action.payload,
				}
			}
		},
	},
})
